var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBoxChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 6,
    fill: "#6FCF97"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8704 6.92347L9.0204 11.8833L6.79757 9.61004C6.4628 9.26769 5.91993 9.26763 5.5851 9.60998C5.25028 9.95239 5.25028 10.5075 5.5851 10.8499L8.41414 13.7432C8.57492 13.9076 8.79298 14 9.02035 14C9.24772 14 9.46583 13.9076 9.62661 13.7432L12.3547 10.9534L15.0829 8.16347C15.4177 7.82106 15.4177 7.26594 15.0829 6.92353C14.748 6.58111 14.2052 6.58105 13.8704 6.92347Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxChecked);
export default __webpack_public_path__ + "static/media/CheckBoxChecked.1eac277b6b568f5ab5e28e6c7341135b.svg";
export { ForwardRef as ReactComponent };